import { Component } from '@theme/component';

class MartGuardFooterMenu extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.initialize();
  }

  updatedCallback() {
    super.updatedCallback();
    this.initialize();
  }

  disconnectedCallback() {
    this.controller?.abort();
    super.disconnectedCallback();
  }

  initialize() {
    this.controller?.abort();
    this.controller = new AbortController();
    const mobile = matchMedia('(max-width: 700px)');
    const setLayout = () => {
      for (const group of this.querySelectorAll('[data-footer-group]')) group.open = !mobile.matches;
    };
    setLayout();
    mobile.addEventListener('change', setLayout, { signal: this.controller.signal });
  }
}

if (!customElements.get('mg-footer-menu')) customElements.define('mg-footer-menu', MartGuardFooterMenu);
